import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton, MenuItem,TextareaAutosize, TextField } from '@mui/material';
import axios from 'axios';

import api from '../../../utils/axiosInstance';

import styles from '../../Form/Form.module.css';

export default function SelectionQuestionEdit(props) {
  const [uploadError, setUploadError] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');
  const [fileContent, setFileContent] = useState(null);
  
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    props.setIsUploadingFile(true);
    try {
      const response = await api.post('validateExcelQuestion', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      props.setSelectedFileSelectQuestion((prev) => ({
        ...prev,
        [props.question.id]: file,
      }));
      props.setQuestion((prev) => ({
        ...prev,
        customOptions: response.data.filas,
        file: file,
      }));
      setUploadSuccess('Archivo válido ✅');
      setUploadError('');
      setFileContent(null);
      // ✅ Quitar error si ya se cargó bien el archivo
      props.setErrorMessage((prev) => ({
        ...prev,
        selectedFileSelectQuestionError: false,
      }));
      props.setHelperText((prev) => ({
        ...prev,
        selectedFileSelectQuestionHelpertext: '',
      }));
    } catch (err) {
      props.setSelectedFileSelectQuestion((prev) => {
        const updated = { ...prev };
        delete updated[props.question.id];
        return updated;
      });
      setUploadSuccess('');
      setUploadError(
        err.response?.data?.message || 'Ocurrió un error al validar el archivo'
      );

      // Mostrar contenido del archivo (solo si es texto plano o se puede leer)
      const reader = new FileReader();
      reader.onload = function (e) {
        setFileContent(e.target.result);
      };
      reader.readAsText(file);
    } finally {
      props.setIsUploadingFile(false); // ✅ Siempre se desactiva después de la carga
    }
  };
  
  const handleRemoveFile = () => {
    props.setSelectedFileSelectQuestion((prev) => {
      const updated = { ...prev };
      delete updated[props.question.id];
      return updated;
    });

    props.setQuestion((prev) => {
      const updated = { ...prev };
      delete updated.file;
      delete updated.customOptions;
      return updated;
    });
    setUploadSuccess('');
    setUploadError('');
    setFileContent(null);
  };

  // ✅ Función para manejar cambios en haveLimit y limitOptions
  const handleChange = (name, value) => {
    props.setQuestion((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className={styles.top}>
      <div className={styles.input} style={{ marginTop: '1rem' }}>
        {!props.question.file && !props.question.customOptions?.length && (
          <label htmlFor={`excel-upload-edit-${props.question.id}`}>
            <input
              accept=".xlsx"
              id={`excel-upload-edit-${props.question.id}`}
              type="file"
              hidden
              onChange={handleFileUpload}
            />
            <Button
              variant="outlined"
              component="span"
              color={
                props.errorMessage.selectedFileSelectQuestionError
                  ? 'error'
                  : 'primary'
              }
              sx={{
                borderColor: props.errorMessage.selectedFileSelectQuestionError
                  ? 'red'
                  : undefined,
              }}
            >
              Subir archivo Excel
            </Button>
            {props.errorMessage.selectedFileSelectQuestionError && (
              <p style={{ color: 'red', marginTop: '0.3rem' }}>
                {props.helperText.selectedFileSelectQuestionHelpertext}
              </p>
            )}
          </label>
        )}

        {(props.question.file || props.question.customOptions?.length > 0) && (
          <div
            style={{
              marginTop: '0.5rem',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span style={{ marginRight: '1rem', color: '#333' }}>
              {props.question.file
                ? <>Archivo: <strong>{props.question.file.name}</strong></>
                : <><strong>{props.question.customOptions.length}</strong> opciones cargadas desde Excel</>
              }
            </span>
            <IconButton size="small" onClick={handleRemoveFile}>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
        {props.isUploadingFile && (
          <p style={{ color: '#888', marginTop: '0.5rem' }}>
            Procesando archivo...
          </p>
        )}
        {uploadError && (
          <p style={{ color: 'red', marginTop: '0.5rem' }}>{uploadError}</p>
        )}
        {uploadSuccess && (
          <p style={{ color: 'green', marginTop: '0.5rem' }}>{uploadSuccess}</p>
        )}
      </div>

      {/* Select para límite de opciones - SIEMPRE VISIBLE */}
      <div className={styles.input} style={{ marginTop: '0.5rem' }}>
        <TextField
          select
          label="Límite de opciones"
          value={props.question.haveLimit ? 'limited' : 'unlimited'}
          name="haveLimit"
          onChange={(e) => {
            const isLimited = e.target.value === 'limited';
            handleChange('haveLimit', isLimited);
            
            // Si cambia a ilimitado, limpiamos el valor del límite
            if (!isLimited) {
              handleChange('limitOptions', '');
            }
          }}
          fullWidth
          size="small"
          helperText="¿Deseas limitar la cantidad de opciones seleccionables?"
        >
          <MenuItem value="unlimited">Ilimitado</MenuItem>
          <MenuItem value="limited">Con límite de opciones</MenuItem>
        </TextField>
      </div>

      {/* Input para límite de opciones (solo si eligió "limited") */}
      {props.question.haveLimit && (
        <div className={styles.input} style={{ marginTop: '0.5rem' }}>
          <TextField
            id="options-limit"
            label="Límite de opciones"
            type="number"
            value={props.question.limitOptions || ''}
            name="limitOptions"
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              let finalValue = value;

              if (isNaN(value) || value < 1) {
                finalValue = 1;
              } else if (value > 10) {
                finalValue = 10;
              }

              handleChange('limitOptions', finalValue);
            }}
            inputProps={{
              min: 1,
              max: 100,
            }}
            error={props.errorMessage.limitOptions}
            helperText={props.helperText.limitOptions || 'Mínimo: 1, Máximo: 10 opciones'}
            fullWidth
            size="small"
            placeholder="Ej: 5"
          />
        </div>
      )}
    </div>
  );
}